/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Performancereport_Currentvalue_Tooltip3Inputs */

const en_coinvestments_performancereport_currentvalue_tooltip3 = /** @type {(inputs: Coinvestments_Performancereport_Currentvalue_Tooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your committed capital × the latest gross MOIC before fees and carry.`)
};

/**
* | output |
* | --- |
* | "Your committed capital × the latest gross MOIC before fees and carry." |
*
* @param {Coinvestments_Performancereport_Currentvalue_Tooltip3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_performancereport_currentvalue_tooltip3 = /** @type {((inputs?: Coinvestments_Performancereport_Currentvalue_Tooltip3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Performancereport_Currentvalue_Tooltip3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_performancereport_currentvalue_tooltip3(inputs)
});
export { coinvestments_performancereport_currentvalue_tooltip3 as "coInvestments_performanceReport_currentValue_tooltip" }